import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Briefcase } from 'lucide-react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const Service2Page = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <button
            onClick={() => navigate('/')}
            className="flex items-center text-blue-600 hover:underline mb-6"
          >
            ← Retour à l'accueil
          </button>

          <div className="bg-white rounded-lg shadow-lg p-8">
            <div className="flex items-center gap-4 mb-6">
              <Briefcase className="text-blue-600" size={48} />
              <h1 className="text-4xl font-bold">Service 2</h1>
            </div>

            <div className="prose max-w-none">
              <p className="text-lg text-gray-700 mb-4">
                Découvrez notre Service 2, conçu pour répondre à vos besoins professionnels.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">Ce que nous offrons</h2>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Solution complète et intégrée</li>
                <li>Interface intuitive et moderne</li>
                <li>Reporting avancé</li>
                <li>Formation incluse</li>
              </ul>

              <h2 className="text-2xl font-bold mt-8 mb-4">Tarification</h2>
              <div className="grid md:grid-cols-3 gap-4 mt-4">
                <div className="border-2 border-gray-200 p-6 rounded-lg text-center">
                  <h3 className="font-bold text-xl mb-2">Basic</h3>
                  <p className="text-3xl font-bold text-blue-600 mb-4">29€/mois</p>
                  <ul className="text-sm text-gray-600 space-y-2">
                    <li>Fonctionnalités de base</li>
                    <li>Support email</li>
                  </ul>
                </div>
                <div className="border-2 border-blue-600 p-6 rounded-lg text-center bg-blue-50">
                  <h3 className="font-bold text-xl mb-2">Pro</h3>
                  <p className="text-3xl font-bold text-blue-600 mb-4">79€/mois</p>
                  <ul className="text-sm text-gray-600 space-y-2">
                    <li>Toutes les fonctionnalités</li>
                    <li>Support prioritaire</li>
                  </ul>
                </div>
                <div className="border-2 border-gray-200 p-6 rounded-lg text-center">
                  <h3 className="font-bold text-xl mb-2">Enterprise</h3>
                  <p className="text-3xl font-bold text-blue-600 mb-4">Sur mesure</p>
                  <ul className="text-sm text-gray-600 space-y-2">
                    <li>Solutions personnalisées</li>
                    <li>Support dédié 24/7</li>
                  </ul>
                </div>
              </div>

              <div className="mt-8">
                <button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition">
                  Commencer l'essai gratuit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Service2Page;